export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";